var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Observable, BehaviorSubject } from 'rxjs';
import { filter, distinctUntilChanged, publishLast } from 'rxjs/operators';
// import { DwUserService, DwUserStorage } from '@webdpt/framework';
import { HttpClient } from '@angular/common/http';
import { isUndefined } from 'util';
import { TranslateService } from '@ngx-translate/core';
import { DwUserService } from '../../../../../projects/webdpt/framework/auth/user.service';
import { DwUserStorage } from '../../../../../projects/webdpt/framework/auth/user-storage';
import { GetloadingService } from '../../../../../projects/webdpt/framework/http';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../projects/webdpt/framework/auth/user-storage";
import * as i2 from "@angular/common/http";
import * as i3 from "@ngx-translate/core";
import * as i4 from "../../../../../projects/webdpt/framework/http/getloading.service";
var FxUserInfoService = /** @class */ (function (_super) {
    __extends(FxUserInfoService, _super);
    function FxUserInfoService(userStorage, http, translateService, load) {
        var _this = _super.call(this, userStorage) || this;
        _this.userStorage = userStorage;
        _this.http = http;
        _this.translateService = translateService;
        _this.load = load;
        _this.userInfoSubject = new BehaviorSubject(null);
        _this.userInfo$ = _this.userInfoSubject.asObservable();
        _this.authedPrograms = [];
        _this.sysEnumsSubject = {};
        _this.programParamSubject = {};
        return _this;
    }
    /**
     * 不登陆的时候取得ent
     * return 返回Observable
     */
    FxUserInfoService.prototype.readEnt = function (ent) {
        var subject1 = new BehaviorSubject(null);
        this.myEnt = ent;
        // const subject: Subject<any> = new Subject(); // 訂閱時, 還未被 new 出來.
        this.setEntInfo(this.myEnt);
        subject1.next(this.myEnt);
        return subject1.asObservable().pipe(filter(function (obsData) { return obsData !== null; }), // 不廣播初始值
        distinctUntilChanged() // 有改變時才廣播
        );
    };
    // 取公共服务
    FxUserInfoService.prototype.getCommonService = function () {
        this.getAllEntParam().subscribe();
        this.getAllSysParam();
        this.getAllOrgParam();
        this.getAllUnitParam();
        this.getAllCurrencyParam();
        // this.getMenuTreeByUser().subscribe(res => {
        //   this.setUser({ id: 'menuTree', value: res });
        // });
    };
    // 获取用户菜单
    FxUserInfoService.prototype.getMenuTreeByUser = function () {
        var _this = this;
        return Observable.create(function (observer) {
            // if (this.userInfo && this.userInfo['menuTree'] && this.userInfo['menuTree'].length) {
            //   observer.next(this.userInfo['menuTree']);
            //   observer.complete();
            // } else {
            _this.http.post('A/IACommonService/getScMenuTreeByUser', {
                param: { "abb001": "SC" }
            }).subscribe(function (response) {
                if (response.data && response.data.length) {
                    observer.next(response.data);
                    observer.complete();
                }
                else {
                    observer.next([]);
                    observer.complete();
                }
            }, function (res) {
                observer.next([]);
                observer.complete();
            });
            // }
        });
    };
    /**
     * 取得使用者資訊
     * return 返回Observable
     */
    FxUserInfoService.prototype.read = function (userId, ent) {
        var _this = this;
        this.myEnt = ent;
        var subject = new BehaviorSubject(null);
        // const subject: Subject<any> = new Subject(); // 訂閱時, 還未被 new 出來.
        var info = {
            success: true,
            description: '',
            userInfo: {} // 取得的回傳值.
        };
        this.http.post('A/ILoginService/getUserInfo', { param: { userId: userId, ent: ent, is_eshop_login: 'Y' } }, { headers: { 'program-code': 'scei001' } }).subscribe(function (userDatas) {
            console.log('userDatas', userDatas);
            var userResult = userDatas.data[0];
            // // 默认经销商获取问题，非经销商角色取cust_list第一笔资料wangce 2408190004
            // if (!userResult.c_cust && userResult['cust_list'] && userResult['cust_list'].length) {
            //   userResult['c_chnl'] = userResult['cust_list'][0].daechnl; //  渠道
            //   userResult['c_cus'] = userResult['cust_list'][0].daechnl; //  渠道
            //   userResult['c_cust'] = userResult['cust_list'][0].daecust; //  渠道商
            //   userResult['c_cust_n1'] = userResult['cust_list'][0].daecust_n1;// 渠道商名称
            //   userResult['c_curr'] = userResult['cust_list'][0].daecurr || userResult['c_curr'];// cust_list未返回daecurr，
            // }
            info.userInfo = userResult;
            _this.org = userResult.c_org;
            // 获取默认渠道
            var idx = userResult.cust_list.findIndex(function (obj) {
                return obj.show_default === 'Y';
            });
            if (idx == -1) {
                idx = userResult.cust_list.findIndex(function (obj) {
                    return obj.dfb002 === userResult.daechnl;
                });
            }
            // 设置当前登陆渠道
            info.userInfo['c_cus'] = userResult.cust_list.length ? userResult.cust_list[idx !== -1 ? idx : 0].daechnl : '';
            info.userInfo['c_cus_n1'] = userResult.cust_list.length ? userResult.cust_list[idx !== -1 ? idx : 0].daechnl_n1 : '';
            // if (userResult.cust_list.length) {
            //   info.userInfo['c_lang'] = userResult.cust_list[idx !== -1 ? idx : 0].mainlang;
            // }
            // info.userInfo['c_lang'] = userResult.cust_list.length ? userResult.cust_list[idx !== -1 ? idx : 0].mainlang : 'zh_CN';
            info.userInfo['c_tourist'] = _this.getEntParamById('c_E147') == userResult['c_user'] ? 'Y' : 'N';
            _this.translateService.setDefaultLang(info.userInfo['c_lang']);
            // this.languageService.setUp(info.userInfo['c_lang']);
            console.log('----------', userResult);
            _this.setUserInfo(userResult);
            _this.getCommonService();
            subject.next(info);
            setTimeout(function () {
                _this.load.getMask('', false);
            }, 800);
        });
        return subject.asObservable().pipe(filter(function (obsData) { return obsData !== null; }), // 不廣播初始值
        distinctUntilChanged() // 有改變時才廣播
        );
    };
    // 集团参数
    FxUserInfoService.prototype.getAllEntParam = function () {
        var _this = this;
        return Observable.create(function (observer) {
            _this.http.post('A/IACommonService/pub_upd_aat', { param: [''], aatent: _this.myEnt }).subscribe(function (sysDatas) {
                if (sysDatas.success) {
                    _this.setUser({ id: 'overAllSys', value: sysDatas.data });
                    observer.next(sysDatas.data || []);
                }
                else {
                    observer.next([]);
                }
                observer.complete();
                setTimeout(function () {
                    _this.load.getMask('', false);
                }, 800);
            });
        });
    };
    // 系统参数
    FxUserInfoService.prototype.getAllSysParam = function () {
        var _this = this;
        this.http.post('A/IACommonService/pub_upd_aas', { param: [''] }).subscribe(function (sysDatas) {
            // console.log(sysDatas);
            if (sysDatas.success) {
                // this.allSccList = sysDatas.data;
                _this.setUser({ id: 'overAllScc', value: sysDatas.data });
            }
            setTimeout(function () {
                _this.load.getMask('', false);
            }, 800);
        });
    };
    // 组织参数参数
    FxUserInfoService.prototype.getAllOrgParam = function () {
        var _this = this;
        this.http.post('A/IACommonService/pub_upd_aau', { param: [''], aaulorg: this.org || '', aauent: '' }).subscribe(function (orgDatas) {
            // console.log(orgDatas);
            if (orgDatas.success) {
                // this.allSccList = sysDatas.data;
                _this.setUser({ id: 'overAllOrg', value: orgDatas.data });
            }
            setTimeout(function () {
                _this.load.getMask('', false);
            }, 800);
        });
    };
    // 单位资料
    FxUserInfoService.prototype.getAllUnitParam = function () {
        var _this = this;
        this.http.post('B/IBCommonService/getUnitList', { "param": {} }).subscribe(function (unitDatas) {
            if (unitDatas.success) {
                _this.setUser({ id: 'overAllUnit', value: unitDatas.data });
            }
            else {
                _this.setUser({ id: 'overAllUnit', value: [] });
            }
        });
        // this.http.post('B/IFxbi003Service/getList', { "queryInfo": { "pageable": true, "pageSize": 1000, "pageNumber": 1, "glikesel": "", "gcomConds": "", "orderfields": [], "condition": { "joinOperator": "AND", "items": [] } } }).subscribe(
        //   (unitDatas: any) => {
        //     console.log(unitDatas);
        //     if (unitDatas.success) {
        //       this.setUser({ id: 'overAllUnit', value: unitDatas.data.datas });
        //     }
        //     setTimeout(() => {
        //       this.load.getMask('',false)
        //     }, 800);
        //   }
        // );
    };
    // 币种资料
    FxUserInfoService.prototype.getAllCurrencyParam = function () {
        var _this = this;
        this.http.post('E/IEShopCommonService/getAllCurrencyInfo', { "param": {} }).subscribe(function (currencyDatas) {
            console;
            if (currencyDatas.success) {
                _this.setUser({ id: 'overAllCurrency', value: currencyDatas.data });
            }
            else {
                _this.setUser({ id: 'overAllCurrency', value: [] });
            }
        });
        // this.http.post('B/IFxbi001Service/getList', { "queryInfo": { "pageable": true, "pageSize": 1000, "pageNumber": 1, "glikesel": "", "gcomConds": "", "orderfields": [], "condition": { "joinOperator": "AND", "items": [] } } }).subscribe(
        //   (currencyDatas: any) => {
        //     console.log(currencyDatas);
        //     if (currencyDatas.success) {
        //       this.setUser({ id: 'overAllCurrency', value: currencyDatas.data.datas });
        //     }
        //     setTimeout(() => {
        //       this.load.getMask('',false)
        //     }, 800);
        //   }
        // );
    };
    FxUserInfoService.prototype.getEntParam = function (aat001) {
        // console.log(this.overAllParam);
        if (aat001.length === 0 || (!this.overAllParam) || (!this.overAllParam.overAllSys)) {
            return;
        }
        var sysList = [];
        var _loop_1 = function (i) {
            sysList.push(this_1.overAllParam.overAllSys.filter(function (obj) { return obj.aat001 === aat001[i]; }) || '');
        };
        var this_1 = this;
        for (var i = 0; i < aat001.length; i++) {
            _loop_1(i);
        }
        return sysList;
    };
    FxUserInfoService.prototype.getEntParamById = function (aat001) {
        if (this.getEntParam([aat001]) && this.getEntParam([aat001]).length && this.getEntParam([aat001])[0].length > 0) {
            return this.getEntParam([aat001])[0][0].aat002;
        }
        else {
            return '';
        }
    };
    FxUserInfoService.prototype.getSysParam = function (aas001) {
        if (aas001.length === 0 || (!this.overAllParam) || (!this.overAllParam.overAllScc)) {
            return;
        }
        var sccList = [];
        var _loop_2 = function (i) {
            sccList.push(this_2.overAllParam.overAllScc.filter(function (obj) { return obj.aas001 === aas001[i]; }) || '');
        };
        var this_2 = this;
        for (var i = 0; i < aas001.length; i++) {
            _loop_2(i);
        }
        return sccList;
    };
    FxUserInfoService.prototype.getSysParamById = function (key) {
        console.log();
        return (this.getSysParam([key]) && this.getSysParam([key]).length) ? this.getSysParam([key])[0][0].aas002 : '';
    };
    FxUserInfoService.prototype.getOrgParam = function (aau001) {
        if (aau001.length === 0 || (!this.overAllParam)) {
            return;
        }
        var orgList = [];
        var _loop_3 = function (i) {
            orgList.push(this_3.overAllParam.overAllOrg.filter(function (obj) { return obj.aau001 === aau001[i]; }) || '');
        };
        var this_3 = this;
        for (var i = 0; i < aau001.length; i++) {
            _loop_3(i);
        }
        return orgList;
    };
    FxUserInfoService.prototype.getOrgParamById = function (key) {
        return this.getOrgParam([key])[0][0].aau002;
    };
    FxUserInfoService.prototype.getUnitParam = function (bacunit) {
        if ((!this.overAllParam)) {
            return;
        }
        var unitList = [];
        if (bacunit.length === 0) {
            unitList = this.overAllParam.overAllUnit;
        }
        else {
            var _loop_4 = function (i) {
                unitList.push(this_4.overAllParam.overAllUnit.filter(function (obj) { return obj.bacunit === bacunit[i]; }) || '');
            };
            var this_4 = this;
            for (var i = 0; i < bacunit.length; i++) {
                _loop_4(i);
            }
        }
        return unitList;
    };
    FxUserInfoService.prototype.getUnitParamById = function (key) {
        return this.getUnitParam([key])[0][0].bacunit;
    };
    FxUserInfoService.prototype.getCurrencyParam = function (baacurr) {
        if ((!this.overAllParam)) {
            return;
        }
        var currencyList = [];
        if (currencyList.length === 0) {
            currencyList = this.overAllParam.overAllCurrency;
        }
        else {
            var _loop_5 = function (i) {
                currencyList.push(this_5.overAllParam.overAllCurrency.filter(function (obj) { return obj.baacurr === baacurr[i]; }) || '');
            };
            var this_5 = this;
            for (var i = 0; i < baacurr.length; i++) {
                _loop_5(i);
            }
        }
        return currencyList;
    };
    FxUserInfoService.prototype.getCurrencyParamById = function (key) {
        return this.getCurrencyParam([key])[0][0].baacurr;
    };
    // 查询枚举值
    FxUserInfoService.prototype.searchAAA = function (key) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.http.post('A/IACommonService/pub_get_aaa', { param: { 'is_enum': 'Y', 'aaa001': key } }).subscribe(function (response) {
                if (response.success && response.data.length > 0) {
                    var resultdata = response.data;
                    observer.next(resultdata);
                }
                else {
                    observer.next([]);
                }
                observer.complete();
            }, function (error) {
                observer.next([]);
                observer.complete();
            });
        });
    };
    // 获取系统枚举值
    FxUserInfoService.prototype.getSysEnumById$ = function (key) {
        if (!this.sysEnumsSubject.hasOwnProperty(key)) {
            var getSysEnumSubject = (this.searchAAA(key)).pipe(publishLast());
            getSysEnumSubject.connect();
            this.sysEnumsSubject[key] = getSysEnumSubject;
        }
        return this.sysEnumsSubject[key];
    };
    // 查询作业参数
    FxUserInfoService.prototype.searchProgramParam = function (key) {
        var _this = this;
        return Observable.create(function (observer) {
            _this.http.post('A/IACommonService/getProgramParam', { param: { 'program_no': key } }).subscribe(function (response) {
                if (response.success && response.data.length > 0) {
                    var resultdata = new Map(response.data.map(function (item) { return [item.aai002, item.aai003]; }));
                    observer.next(resultdata);
                }
                else {
                    observer.next(new Map());
                }
                observer.complete();
            }, function (error) {
                observer.next(new Map());
                observer.complete();
            });
        });
    };
    // 获取作业参数
    FxUserInfoService.prototype.getProgramParamById$ = function (key) {
        if (!this.programParamSubject.hasOwnProperty(key)) {
            var getPPSubject = (this.searchProgramParam(key)).pipe(publishLast());
            getPPSubject.connect();
            this.programParamSubject[key] = getPPSubject;
        }
        return this.programParamSubject[key];
    };
    FxUserInfoService.prototype.clearUserInfo = function () {
        // this.userStorage.remove('DwFxed020UserInfo');
        this.userInfo = {};
        // this.myEnt = null;
        // this.userStorage.remove('DwSysInfo');
        this.overAllParam = {};
        this.sysEnumsSubject = {}; // 系统分类
        this.programParamSubject = {}; // 作业参数
        return true;
    };
    FxUserInfoService.prototype.setAuthedProgram = function (programs) {
        this.authedPrograms = programs;
        return true;
    };
    FxUserInfoService.prototype.checkProgramAuthed = function (programId) {
        return isUndefined(this.authedPrograms.find(function (item) { return item === programId; }));
    };
    FxUserInfoService.ngInjectableDef = i0.defineInjectable({ factory: function FxUserInfoService_Factory() { return new FxUserInfoService(i0.inject(i1.DwUserStorage), i0.inject(i2.HttpClient), i0.inject(i3.TranslateService), i0.inject(i4.GetloadingService)); }, token: FxUserInfoService, providedIn: "root" });
    return FxUserInfoService;
}(DwUserService));
export { FxUserInfoService };
